import { Component } from '@angular/core';
import { Router } from '@angular/router';

import { AuthLoginService } from '../../../service/auth-login/auth-login.service';
import { AuthHashkeyService } from '../../../service/auth-hashkey/auth-hashkey.service';
import { CommonService } from '../../../service/common/common.service';
import { DialogsService } from '../../../../component/dialog/dialogs.service';
import { OwnerService } from '../../../service/owner/owner.service';
import { OwnerFunctionService } from '../../../service/owner-function/owner-function.service';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: 'wa0001.component.html',
  styleUrls: ['wa0001.component.scss']
})
export class Wa0001Component {
  public componentTitle = 'ログイン';

  public userCd: string;
  public password: string;
  public companyCd: string;
  public apiKey: string = 'dummy-api-key';
  public production = environment.production;
  public backgroundColor: string;
  public working = false;
  public errorInfo = [];

  constructor(
    private router: Router,
    private authLoginService: AuthLoginService,
    private authHashkeyService: AuthHashkeyService,
    private commonService: CommonService,
    private dialogsService: DialogsService,
    private ownerFunctionService: OwnerFunctionService,
    private ownerService: OwnerService
  ) {
    if (this.production) {
      this.backgroundColor = 'primary';
    } else {
      this.backgroundColor = 'warn';
    }
    this.companyCd = localStorage.getItem('companyCd');

    setTimeout(() => {
      this.verifyLogin();
    }, 300);

    localStorage.setItem('apiKey', this.apiKey);
  }

  verifyLogin() {
    const result = sessionStorage.getItem('loginResult');
    let pgUrl = localStorage.getItem("srcPgUri");
    let checkRouter = this.router.config.filter((route, index) => {
      if (route.path === pgUrl) return true;
    });
    
    let accessPg = pgUrl && checkRouter && pgUrl !== 'wa0001' ? pgUrl
       : result !== null && JSON.parse(result).user.roleId === 3 ? 'wa0003' : 'wa0002';
    if (result !== null) {
      this.redirectToAccessPage(accessPg)
    }
  }

  onSubmit() {
    this.working = true;
    this.errorInfo = [];
    if (this.userCd === undefined || this.userCd === '') {
      this.working = false;
      this.errorInfo.push('ユーザコードが未入力です。');
    }

    if (this.password === undefined || this.password === '') {
      this.working = false;
      this.errorInfo.push('パスワードが未入力です。');
    }

    if (this.companyCd === undefined || this.companyCd === '') {
      this.working = false;
      this.errorInfo.push('会社コードが未入力です。');
    }

    if (this.errorInfo.length > 1) return;
    sessionStorage.removeItem('baseUrlCompany');
    sessionStorage.setItem('baseUrlCompany', this.companyCd);
    let pgUrl = localStorage.getItem("srcPgUri");
    let checkRouter = this.router.config.filter((route, index) => {
      if (route.path === pgUrl) return true;
    });
    
    this.authLoginService
      .execute(this.userCd, this.password, this.companyCd, this.apiKey)
      .then(outputJson => {
        localStorage.setItem('companyCd', this.companyCd);
        sessionStorage.setItem('loginResult', JSON.stringify(outputJson));
        localStorage.removeItem("srcPgUri");

        const loginResult = JSON.parse(sessionStorage.getItem('loginResult'));

        this.ownerFunctionService
            .getOwnerFunctions()
            .then(outputJson => {
              if (loginResult.user.roleId == '3') {
                if (loginResult.user.linkedownerId == null) {
                  this.errorInfo.push('荷主との紐付がされていない荷主ユーザです。');
                  this.working = false;
                  return;
                }
      
                this.ownerService
                .get()
                .then(outputJson1 => {
                  const owners = outputJson1.owners;
                  let selectOwner;
                  for (let i = 0; i < owners.length; i++) {
                    if (owners[i].ownerId ===  loginResult.user.linkedownerId)
                      selectOwner = owners[i];
                  }
                  if (selectOwner ==null) {
                    this.errorInfo.push('ユーザに紐づけられた荷主IDが不正です。');
                    this.working = false;
                    return;
                  }
                  sessionStorage.setItem('showShortcutMenu', '1');
                  sessionStorage.setItem('ownerFunctions', JSON.stringify(outputJson));

                  let accessPg = pgUrl && checkRouter && pgUrl !== 'wa0001' ? pgUrl : 'wa0003';
                  this.redirectToAccessPage(accessPg);
                })
                .catch(error => {
                  this.errorInfo.push('紐づけ荷主の有効性の確認時にエラーが発生しました。');
                  this.working = false;
                  return;
                });
              } else {
                sessionStorage.setItem('showShortcutMenu', '1');
                sessionStorage.setItem('ownerFunctions', JSON.stringify(outputJson));

                let accessPg = pgUrl && checkRouter && pgUrl !== 'wa0001' ? pgUrl : 'wa0002';
                this.redirectToAccessPage(accessPg);
              }
            })
            .catch(error =>{
              localStorage.removeItem('companyCd');
              sessionStorage.removeItem('loginResult');
              sessionStorage.removeItem('showShortcutMenu');
              this.errorInfo.push('荷主別使用機能マスタが取得できませんでした。取得処理に失敗したか、接続先情報が間違っている可能性があります。管理者に連絡してください。');
              this.working = false;
            });
        
      })
      .catch(error => {
        if (error.ok === undefined) {
          this.errorInfo.push('サーバーへの接続に失敗しました。管理者に連絡してください。');
        } else {
          this.errorInfo.push('会社コードまたはユーザコードまたはパスワードが違います。');
        }
        this.working = false;
      });
  }

  redirectToAccessPage (accessPg) {
    let path = accessPg
    const params = {}
    const position = accessPg.indexOf('?')
    if (position !== -1) {
      path = accessPg.substring(0, position)

      const queryString = accessPg.substring(position + 1)
      queryString.split('&').forEach(q => {
        const qs = q.split('=')
        params[qs[0]] = qs[1]
      })
    }
    this.router.navigate([ path ], {
      queryParams: params
    });
    localStorage.removeItem("srcPgUri");
  }
}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/pages/wa0Common/wa0001/wa0001.component.ts